import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oops',
  templateUrl: './oops.component.html',
  styleUrls: ['./oops.component.scss']
})
export class OopsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
